const PLACEHOLDER_MARKERS = [
  '[Marketplace Name]',
  'Your marketplace',
  'Content → Footer',
  'Content -> Footer',
];

const isPlaceholderText = text =>
  typeof text === 'string' &&
  PLACEHOLDER_MARKERS.some(marker => text.includes(marker));

const patchTextField = (field, replacement) => {
  if (!field || !replacement) {
    return field;
  }
  if (isPlaceholderText(field.content)) {
    return { ...field, content: replacement };
  }
  return field;
};

/**
 * Replace Sharetribe Console placeholder footer copy until Console assets are finalized.
 */
export const patchPlaceholderFooter = (footer, { marketplaceName, slogan, copyright }) => {
  if (!footer || typeof footer !== 'object') {
    return footer;
  }

  return {
    ...footer,
    slogan: patchTextField(footer.slogan, slogan),
    copyright: patchTextField(footer.copyright, copyright),
    blocks: Array.isArray(footer.blocks)
      ? footer.blocks.map(block => {
          if (!block || typeof block !== 'object') {
            return block;
          }
          return {
            ...block,
            title: patchTextField(block.title, marketplaceName),
          };
        })
      : footer.blocks,
  };
};
